import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { APP_ROUTE_URLS } from '../app-config/routing/app-route-paths';
import { AuthStoreService } from '../../shared/store/auth-store.service';

export const loginGuard: CanActivateFn = () => {
  const authStoreService = inject(AuthStoreService);
  const router = inject(Router);

  return authStoreService.isLoggedInWhenReady$().pipe(
    map((isLoggedIn) => (isLoggedIn ? router.parseUrl(APP_ROUTE_URLS.root) : true)),
  );
};
